import { FilterButtonFilterObject } from 'common/components/widgets/widget-subcomponents/DashboardWidgetFilterButton';
import { CommonFiltersItem, FilterParent } from 'common/models/filter.model';
import { RootState } from 'common/store';
import { selectCommonFilters } from 'common/store/slices/common-filters.slice';
import { selectId, selectOverrideDateFilter } from 'common/store/slices/dashboard-editor.slice';
import { selectDateFilter } from 'common/store/slices/date-filter.slice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export interface UseUniversalFilters {
  dashboardId: string | undefined;
  datasetId: string;
  universalFilters: FilterButtonFilterObject | undefined;
}

function useUniversalFilters(): UseUniversalFilters {
  const { tab: urlDashboardId } = useParams();
  const reduxDashboardId = useSelector(selectId);

  const dashboardId = isNaN(Number(urlDashboardId ?? reduxDashboardId))
    ? 0
    : Number(urlDashboardId ?? reduxDashboardId);

  const datasetId = `universal-${dashboardId}`;

  const { startDate, endDate, visualType, visualData } = useSelector((state: RootState) =>
    selectDateFilter(state, datasetId)
  );

  const universalFilters = useSelector((state: RootState) => selectCommonFilters(state, datasetId));
  const overrideDateFilter = useSelector(selectOverrideDateFilter);

  const value = useMemo(
    () => ({
      dashboardId: dashboardId?.toString(),
      datasetId,
      universalFilters: {
        filterParent: FilterParent.UNIVERSAL,
        startDate: startDate,
        endDate: endDate,
        visualData: visualData,
        visualDataType: visualType,
        filters: universalFilters ?? ({} as CommonFiltersItem),
        overrideDateFilter,
      },
    }),
    [
      dashboardId,
      datasetId,
      startDate,
      endDate,
      visualData,
      visualType,
      universalFilters,
      overrideDateFilter,
    ]
  );

  return value;
}

export default useUniversalFilters;
